<div class="container">
    <div class="content-box">
      <h2>
        <div class="left-titl-buton ">
            <div  class="back-btn-new" (click)="backbutton()">
                <img  src="../../../assets/images/back_button_popup.svg" alt="Back-Button">
            </div>
            <div class="title">
              Add Data Source
            </div>
        </div></h2>
        <!-- <div class="form-data-source">
          <div class="row">
            <div class="left"></div>
            <div class="right"></div>
          </div>
        </div> -->
        <div class="data">
      <div class="Info">  
      <div class="custom-select">
        <mat-label class="LabelP">Source Name</mat-label>
        <mat-select class="SelectD" (selectionChange)="selectSource($event.value)" placeholder="Choose Data Source" value="Chat">
          <mat-option *ngFor="let item of dataSourceArr;" value="  {{item}}">  {{item}}</mat-option>
        </mat-select>
      </div> 
      </div>
      <div class="labeltext">
        <div class="Inputarea">
          <label for="sourcePath">Source Path</label>
          <input
            id="sourcePath"
            [(ngModel)]="sourcePath"
            name="sourcePath"
            class="InputFld custom-input"
            required
            rows="3"
          />
          <button class="btn-clr" (click)="decodeAndShow()">Decode path</button>
        </div>
        <div class="Inputarea">
          <label for="decodedUrl" class="decodeLabel">Decoded URL </label>
          <p row="3" class="word-wrap">{{decodedUrl}}</p>         
          <button  class="btn-clr max-height-32" (click)="copyToClipboard()" >Copy path</button>
        </div>

        <div class="Inputarea">
          <label for="region">Region</label>
          <input id="region" [(ngModel)]="region" name="region" class="InputFld custom-input" required />
        </div>

        <div class="Inputarea">
          <label for="primary_market">Primary Market</label>
          <input id="primary_market" [(ngModel)]="primary_market" name="primary_market" class="InputFld custom-input" required />
        </div>

        <div class="Inputarea">
          <label for="product_group">Product Group</label>
          <input id="product_group" [(ngModel)]="product_group" name="product_group" class="InputFld custom-input" required />
        </div>
        <!-- <div class="Inputarea">
          <label for="is_internal">Is Internal:</label>
          <input id="is_internal" [(ngModel)]="is_internal" name="is_internal" class="InputFld custom-input" required />
        </div> -->
        <div class="Info">  
          <div class="custom-select">
            <mat-label class="LabelP">Is Internal</mat-label>
            <mat-select class="SelectD" (selectionChange)="selectIsInternal($event.value)" value=""  placeholder="Choose Internal">
              <mat-option value="Yes">Yes</mat-option>
              <mat-option value="No">No</mat-option>
            </mat-select>
          </div> 
          </div>
        <div class="Info">  
          <div class="custom-select">
            <mat-label class="LabelP">Copy Approved</mat-label>
            <mat-select class="SelectD" (selectionChange)="selectCopyApproved($event.value)" value=""  placeholder="Choose Copy Approved">
              <mat-option value="Yes">Yes</mat-option>
              <mat-option value="No">No</mat-option>
            </mat-select>
          </div> 
          </div>
        <!-- <div class="Inputarea">
          <label for="copy_approved">Copy Approved:</label>
          <input id="copy_approved" [(ngModel)]="copy_approved" name="copy_approved" class="InputFld custom-input" required />
        </div> -->
      <!-- <div class="Info"> 
        <div class="custom-multi-select">
        <mat-label class="LabelP">Business Unit</mat-label>
        <mat-form-field> -->
          <!-- <mat-label>File Extensions</mat-label> -->
          <!-- <mat-select class="SelectD" (selectionChange)="selectFileExt($event.value)" placeholder="Select Option" multiple>
            <mat-option *ngFor="let doc of docList" [value]="doc">
              <mat-checkbox [checked]="isSelected(doc)" (change)="toggleSelection($event.checked,doc)">
                {{ doc }}
              </mat-checkbox>
            </mat-option>
          </mat-select>
        </mat-form-field>
    </div>
    </div> -->
    <button mat-raised-button (click)="save()" class="btn-red">Save</button>

</div>
  </div>
  